/**
 * Franja de utilidades THCC (sections/thcc-nav-utilidades.liquid): muestra las frases de promociones
 * una por una, deslizándose en horizontal (la nueva entra por la derecha y la anterior sale por la
 * izquierda; con la flecha "anterior", al revés). Las flechas ‹ › cambian la frase a mano y reinician
 * el temporizador. Todas las frases están en el HTML (sin JS se ve la primera). Se pausa con el puntero
 * o el foco encima y con la pestaña oculta. Con movimiento reducido cambia sin deslizar (CSS).
 */

const INTERVALO = 4000;

class ThccUtilRota extends HTMLElement {
  /** @type {number | undefined} */
  #timer;
  #pausa = false;
  /** @type {AbortController | undefined} */
  #abort;

  connectedCallback() {
    this.#abort?.abort();
    this.#abort = new AbortController();
    const { signal } = this.#abort;

    if (this.#frases().length < 2) return;

    const pausar = () => {
      this.#pausa = true;
    };
    const seguir = () => {
      this.#pausa = false;
    };
    this.addEventListener('pointerenter', pausar, { signal });
    this.addEventListener('pointerleave', seguir, { signal });
    this.addEventListener('focusin', pausar, { signal });
    this.addEventListener('focusout', seguir, { signal });

    this.addEventListener(
      'click',
      (event) => {
        const flecha = /** @type {Element} */ (event.target).closest?.('[data-dir]');
        if (!(flecha instanceof HTMLElement)) return;
        event.preventDefault();
        this.#mover(Number(flecha.dataset.dir) || 1);
        this.#iniciar();
      },
      { signal }
    );

    this.#iniciar();
  }

  disconnectedCallback() {
    this.#abort?.abort();
    window.clearInterval(this.#timer);
  }

  #iniciar() {
    window.clearInterval(this.#timer);
    this.#timer = window.setInterval(() => {
      if (this.#pausa || document.hidden) return;
      this.#mover(1);
    }, INTERVALO);
  }

  #frases() {
    return /** @type {HTMLElement[]} */ ([...this.querySelectorAll('.thcc-util__frase')]);
  }

  /** @param {number} dir 1 = siguiente (entra por la derecha), -1 = anterior (entra por la izquierda) */
  #mover(dir) {
    const frases = this.#frases();
    const actual = Math.max(0, frases.findIndex((frase) => frase.hasAttribute('data-activa')));
    const destino = (actual + dir + frases.length) % frases.length;
    this.style.setProperty('--thcc-util-entra', dir > 0 ? '60%' : '-60%');
    this.style.setProperty('--thcc-util-sale', dir > 0 ? '-60%' : '60%');

    // La frase que entra arranca, sin transición, del lado correcto antes de deslizarse.
    const entra = frases[destino];
    entra.style.transition = 'none';
    entra.removeAttribute('data-sale');
    void entra.offsetWidth;
    entra.style.transition = '';

    for (const [i, frase] of frases.entries()) {
      frase.toggleAttribute('data-activa', i === destino);
      frase.toggleAttribute('data-sale', i === actual && i !== destino);
      frase.setAttribute('aria-hidden', String(i !== destino));
    }
  }
}

if (!customElements.get('thcc-util-rota')) {
  customElements.define('thcc-util-rota', ThccUtilRota);
}
